
import { withStyles } from '@material-ui/core/styles';
import React from 'react';
import { translate } from 'react-i18next';
import { connect } from 'react-redux';
import { style } from './style';
import queryString from 'query-string';
import {isJsonString} from '../../utils/setting'
import BarCode from 'react-barcode';

class BarCodeComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            barcodeValue: '',
            barcodeSize: 170
        };
    }

    async componentDidMount() { 
        const parsed = queryString.parse(this.props.location.search);
        let serviceCode = parsed.serviceCode
        let size = parsed.size
        let result = await this.props.getInfoQRcode({serviceCode})
        if(result.code === 1) {
            let barcode = isJsonString(result.data.barcode) ? JSON.parse(result.data.barcode) : {
                value: '',
            }
            let barcodeValue = `${barcode.code}`
            this.setState({barcodeValue: barcodeValue, barcodeSize: size})
        }
    }
    render() {
        const {classes} = this.props
        let {barcodeValue, barcodeSize = 170} = this.state
        return (
            <div className = {classes.container}>
            <BarCode
                value={barcodeValue}
                height={barcodeSize}
                // width = {(barcodeSize * 2)}
                lineColor='#000000'
                background= '#ffffff'
                renderer = 'canvas'
            /> 
            </div>
        )
    }
} 
const mapState = state => ({

});

const mapDispatch = dispatch => ({
    getInfoQRcode: dispatch.service.getInfoQRcode
});

export default connect(mapState, mapDispatch)(translate('translations')(withStyles(style, { withTheme: true })(BarCodeComponent)));
